import { Link } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";

const PRODUCT_LINKS: { label: string; to: string }[] = [
  { label: "Features", to: "/demonstration" },
  { label: "Integrations", to: "/product#integrations" },
  { label: "Pricing", to: "/product#pricing" },
  { label: "Changelog", to: "/changelog" },
];
const COMPANY_LINKS: { label: string; href: string }[] = [
  { label: "About", href: "/about" },
];
const LEGAL_LINKS: { label: string; href: string }[] = [
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms of Service", href: "/terms" },
  { label: "Security", href: "/security" },
];

export default function Footer() {
  const { isDark } = useTheme();

  const socials = [
    {
      label: "X (Twitter)",
      handle: "@usetrackly",
      icon: "ri-twitter-x-fill",
      imgSrc: "https://storage.readdy-site.link/project_files/d2fca44a-eb94-4797-9168-15f21f7a5589/7c4a3f62-9d76-40b6-9e43-3fce62dc6c6e_X-Logo.png?v=9928d9c65f8e3db4a5a51f88e3be6a7d",
      invertOnDark: true,
      imgSize: "w-5 h-5",
      href: "https://x.com/usetrackly",
    },
    {
      label: "Instagram",
      handle: "@usetrackly",
      icon: "ri-instagram-fill",
      imgSrc: "https://static.readdy.ai/image/1de166adf1bbf13a9e4054af96cf4ae8/907fda1763aab42155461943ef6de0d8.webp",
      invertOnDark: false,
      imgSize: "w-4 h-4",
      href: "https://instagram.com/usetrackly",
    },
    {
      label: "TikTok",
      handle: "@usetrackly",
      icon: "ri-tiktok-fill",
      imgSrc: "https://storage.readdy-site.link/project_files/d2fca44a-eb94-4797-9168-15f21f7a5589/68f04236-6d28-4cf2-a183-0dc76966705b_tiktok-logo-tikok-icon-transparent-tikok-app-logo-free-png.png?v=f4b9689355e39ba27d0fdaba5b509f5b",
      invertOnDark: true,
      imgSize: "w-5 h-5",
      href: "https://tiktok.com/@usetrackly",
    },
  ];

  return (
    <footer className={`pt-20 pb-10 px-8 lg:px-16 transition-colors duration-300 ${isDark ? "bg-[#030303]" : "bg-[#f0f0f0]"}`}>
      <div className="max-w-7xl mx-auto">
        {/* Top Grid */}
        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 pb-16 border-b ${isDark ? "border-white/5" : "border-black/8"}`}>
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/">
              <img
                src="https://public.readdy.ai/ai/img_res/83fc83b2-e53d-4b28-ae49-56c4b15eb9d6.png"
                alt="Trackly logo"
                className={`h-8 w-auto object-contain mb-5 transition-all duration-300 ${!isDark ? "invert" : ""}`}
              />
            </Link>
            <p className={`font-inter text-sm leading-relaxed max-w-xs ${isDark ? "text-[#555555]" : "text-[#666666]"}`}>
              Know your real margins on every sale. Built for resellers of cards, sneakers, clothing, and anything worth flipping.
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h4 className={`font-syne text-sm font-semibold mb-5 ${isDark ? "text-white" : "text-[#111111]"}`}>
              <a href="#">Product</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {PRODUCT_LINKS.map((item) => (
                <li key={item.label}>
                  {item.to.startsWith("#") ? (
                    <a href={item.to} rel="nofollow" className={`font-inter text-sm transition-colors duration-200 cursor-pointer ${isDark ? "text-[#555555] hover:text-white" : "text-[#666666] hover:text-[#111111]"}`}>
                      {item.label}
                    </a>
                  ) : (
                    <Link to={item.to} className={`font-inter text-sm transition-colors duration-200 cursor-pointer ${isDark ? "text-[#555555] hover:text-white" : "text-[#666666] hover:text-[#111111]"}`}>
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className={`font-syne text-sm font-semibold mb-5 ${isDark ? "text-white" : "text-[#111111]"}`}>
              <a href="#">Company</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {[...COMPANY_LINKS, ...LEGAL_LINKS].map((item) => (
                <li key={item.label}>
                  {item.href.startsWith("/") ? (
                    <Link to={item.href} className={`font-inter text-sm transition-colors duration-200 cursor-pointer ${isDark ? "text-[#555555] hover:text-white" : "text-[#666666] hover:text-[#111111]"}`}>
                      {item.label}
                    </Link>
                  ) : (
                    <a href={item.href} rel="nofollow" className={`font-inter text-sm transition-colors duration-200 cursor-pointer ${isDark ? "text-[#555555] hover:text-white" : "text-[#666666] hover:text-[#111111]"}`}>
                      {item.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Socials */}
          <div>
            <h4 className={`font-syne text-sm font-semibold mb-5 ${isDark ? "text-white" : "text-[#111111]"}`}>Follow Us</h4>
            <div className="flex flex-col gap-4">
              {socials.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className={`flex items-center gap-3 group cursor-pointer`}
                >
                  <div className={`w-9 h-9 flex items-center justify-center rounded-xl transition-all duration-200 flex-shrink-0 ${
                    isDark
                      ? "bg-white/5 group-hover:bg-white/12"
                      : "bg-black/8 group-hover:bg-black/14"
                  }`}>
                    {social.imgSrc ? (
                      <img
                        src={social.imgSrc}
                        alt={social.label}
                        className={`${social.imgSize ?? "w-4 h-4"} object-contain transition-all duration-200 ${social.invertOnDark && isDark ? "invert" : ""}`}
                      />
                    ) : (
                      <i className={`${social.icon} text-base transition-colors duration-200 ${
                        isDark
                          ? "text-[#666666] group-hover:text-white"
                          : "text-[#777777] group-hover:text-[#111111]"
                      }`} />
                    )}
                  </div>
                  <div>
                    <p className={`font-syne text-xs font-semibold leading-tight ${isDark ? "text-[#888888] group-hover:text-white" : "text-[#888888] group-hover:text-[#111111]"} transition-colors duration-200`}>{social.label}</p>
                    <p className={`font-inter text-sm leading-tight ${isDark ? "text-[#555555] group-hover:text-[#aaaaaa]" : "text-[#aaaaaa] group-hover:text-[#555555]"} transition-colors duration-200`}>{social.handle}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8">
          <p className={`font-inter text-xs ${isDark ? "text-[#444444]" : "text-[#aaaaaa]"}`}>
            &copy; 2026 Trackly. All rights reserved.
          </p>
          <p className={`font-inter text-xs ${isDark ? "text-[#444444]" : "text-[#aaaaaa]"}`}>
            Built for teams who demand precision.
          </p>
        </div>
      </div>
    </footer>
  );
}
